import { createSlice } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

const initialState = {
    formHasErrored: false,
    formIsLoading: false,
    formSuccess: false,
}

const userSlice = createSlice({
    name: 'User',
    initialState,
    reducers: {
        resetState(state) {
            state.formIsLoading = false
            state.formSuccess = false
            state.formHasErrored = false
        },
        formError(state, { payload }) {
            state.formHasErrored = payload
        },
        formSuccess(state) {
            state.formIsLoading = false
            state.formSuccess = true
            state.formHasErrored = false
        },
        formLoading(state, { payload }) {
            state.formIsLoading = payload
            state.formSuccess = false
        },
        cleanForm(state) {
            state.formSuccess = false
            state.formIsLoading = false
        },
    },
})

export const { actions } = userSlice
export default userSlice.reducer

export const useUserActions = () => {
    const dispatch = useDispatch()

    const resetState = () => {
        return dispatch(actions.resetState())
    }
    const formError = message => {
        return dispatch(actions.formError(message))
    }
    const formSuccess = () => {
        return dispatch(actions.formSuccess())
    }
    const formLoading = loading => {
        return dispatch(actions.formLoading(loading))
    }

    const cleanForm = () => {
        return dispatch(actions.cleanForm())
    }

    return {
        resetState,
        formError,
        formSuccess,
        formLoading,
        cleanForm,
    }
}
